import * as React from 'react';
import './App.css';
import {HashRouter, Switch, Route, Redirect} from 'react-router-dom';
import asyncComponent from './utils/asyncComponent';
import {Toast} from 'antd-mobile';

import home from "./module/homePage/home";

const questionDetail = asyncComponent(() => import("./module/questionDetail/questionDetail"));

class App extends React.Component {

    componentWillMount() {
        Toast.loading('正在加载中...', 0);
    }

    async componentDidMount() {
        setTimeout(
            () => {
                Toast.hide();
            })
    }

    render() {
        return (
            <HashRouter>
                <Switch>
                    <Route path="/" exact component={home}/>
                    <Route path="/questionDetail" component={questionDetail}/>
                    <Redirect to="/"/>
                </Switch>
            </HashRouter>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx